"use strict";

exports.__esModule = true;
exports.OperatorPanelCollectionContext = void 0;
var _Utils = require("../../../Utils");
var _OperatorPanelCollection = require("./OperatorPanelCollection");
var OperatorPanelCollectionContext = exports.OperatorPanelCollectionContext = (0, _Utils.createEnhancedContext)({
  propName: "operatorPanelCollection",
  defaultController: _OperatorPanelCollection.OperatorPanelCollection
});